import { Typography, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import AddUGProducers from "./AddUGProducers";
import AddUGProducersModules from "./AddUGProducersModules";
import { Usina, PostUsina, Producer, PostUG } from "../types";
import { useContext, useState } from "react";
// import {
//   Form,
//   SubmitErrorHandler,
//   SubmitHandler,
//   useForm,
// } from "react-hook-form";
import React from "react";
import BaseButton from "../../../main/components/BaseButton";
import { MainContext } from "../../../main/context/MainContextProvider";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import AddUGProducersTrackers from "./AddUGProducersTrackers";

import { ActionAlert } from "../../../main/components/alerts/ActionAlert";

import { ConfirmationModal } from "../../../main/components/ConfirmationModal";

interface AddUGFormProps {
  usina: Usina | PostUsina | null;
  onSave: (ug: PostUG) => void;
  onSubmit: () => void;
  onClose: () => void;
  onMount: () => void;
}

const AddUGForm: React.FC<AddUGFormProps> = ({
  onSave,
  onSubmit,
  onClose,
  onMount,
}) => {
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;

  const [nameUG, setNameUG] = useState<number>(0);
  const [amountInversores, setAmountInversores] = useState<string>("");
  const [inverterPower, setInverterPower] = useState<string>("");
  const [amountString, setAmountString] = useState<string>("");
  const [powerString, setPowerString] = useState<string>("");
  const [amountTrackers, setAmountTrackers] = useState<string>("");
  const [amountModules, setAmountModules] = useState<string>("");
  const [powerModules, setPowerModules] = useState<string>("");
  const [ugProducersData, setUGProducersData] = useState<Producer[]>([]);
  const [ugProducersDataTrackers, setUGProducersDataTrackers] = useState<
    Producer[]
  >([]);
  const [ugProducersDataModules, setUGProducersDataModules] = useState<
    Producer[]
  >([]);
  const [isSaveConfirmationOpen, setSaveConfirmationOpen] =
    useState<boolean>(false);

  const [openSuccessModal, setOpenSuccessModal] = useState<boolean>(false);
  const [openErrorModal, setOpenErrorModal] = useState<boolean>(false);

  const handleSave = () => {
    setSaveConfirmationOpen(true);
  };
  const handleSubmit = async () => {
    // Cria uma instância de UG usando os valores do formulário
    const ug: PostUG = {
      number: nameUG,
      components: {
        inverters: {
          amount: parseInt(amountInversores, 10),
          inverterPower: parseInt(inverterPower, 10),
          producers: ugProducersData,
        },
        string: {
          amount: parseInt(amountString, 10),
          power: parseInt(powerString, 10),
        },
        trackers: {
          amount: parseInt(amountTrackers, 10),
          producers: ugProducersDataTrackers,
        },
        modules: {
          amount: parseInt(amountModules, 10),
          power: parseInt(powerModules, 10),
          producers: ugProducersDataModules,
        },
      },
    };

    // Envia a instância de UG para a função onSave
    onSave(ug);

    // Chama a função onSubmit para lidar com o envio do formulário
    onSubmit();
  };

  const cancelarCadastroUG = () => {
    onClose();
  };

  return (
    <>
      <>
        <Grid
          container
          sx={{
            padding: "20px",
            flexDirection: "row",
            display: "flex",
            backgroundColor: "rgba(217, 217, 217, 0.1)",
            borderRadius: 2,
            marginTop: "8px",
            marginBottom: "8px",
            rowGap: "16px ",
            width: "100%",
          }}
        >
          <Grid item xs={6} textAlign={"start"}>
            <Typography>Número da UG</Typography>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "-3px" }}>
            <Grid item xs={12} md={3}>
              <TextField
                value={nameUG}
                onChange={(e) => setNameUG(Number(e.target.value))}
                size="small"
                type="number"
                inputProps={{
                  min: 0,
                }}
                fullWidth
                InputLabelProps={{ shrink: true }}
                style={{ fontSize: 16 }}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
      <>
        <Grid
          container
          sx={{
            padding: "20px",
            flexDirection: "row",
            display: "flex",
            backgroundColor: "rgba(217, 217, 217, 0.1)",
            borderRadius: 2,
            marginTop: "8px",
            marginBottom: "8px",
            rowGap: "16px ",
            width: "100%",
          }}
        >
          <Grid item xs={6} textAlign={"start"}>
            <Typography>Inversores</Typography>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "-3px" }}>
            <Grid item xs={12} md={3}>
              <TextField
                label="N° de Inversores"
                value={amountInversores}
                onChange={(e) => setAmountInversores(e.target.value)}
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
                style={{ fontSize: 16 }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Potência Inversor"
                value={inverterPower}
                onChange={(e) => setInverterPower(e.target.value)}
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
                style={{ fontSize: 16 }}
              />
            </Grid>
          </Grid>
          <Grid sx={{ marginTop: "30px" }}>
            <AddUGProducers
              producers={ugProducersData}
              setProducers={setUGProducersData}
            />
          </Grid>
        </Grid>
      </>
      <Grid
        container
        sx={{
          padding: "20px",
          flexDirection: "row",
          display: "flex",
          backgroundColor: "rgba(217, 217, 217, 0.1)",
          borderRadius: 2,
          marginTop: "8px",
          marginBottom: "8px",
          rowGap: "16px ",
          width: "100%",
        }}
      >
        <Grid item xs={6} textAlign={"start"}>
          <Typography>String</Typography>
        </Grid>
        <Grid container spacing={2} sx={{ marginTop: "-3px" }}>
          <Grid item xs={12} md={3}>
            <TextField
              label="Quantidade"
              value={amountString}
              onChange={(e) => setAmountString(e.target.value)}
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ fontSize: 16 }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Potência"
              value={powerString}
              onChange={(e) => setPowerString(e.target.value)}
              size="small"
              fullWidth
              InputLabelProps={{ shrink: true }}
              style={{ fontSize: 16 }}
            />
          </Grid>
        </Grid>
      </Grid>
      <>
        <Grid
          container
          sx={{
            padding: "20px",
            flexDirection: "row",
            display: "flex",
            backgroundColor: "rgba(217, 217, 217, 0.1)",
            borderRadius: 2,
            marginTop: "8px",
            marginBottom: "8px",
            rowGap: "16px ",
            width: "100%",
          }}
        >
          <Grid item xs={6} textAlign={"start"}>
            <Typography>Trackers</Typography>
          </Grid>
          <Grid container spacing={2} sx={{ marginTop: "-3px" }}>
            <Grid item xs={12} md={3}>
              <TextField
                label="N° de Trackers"
                value={amountTrackers}
                onChange={(e) => setAmountTrackers(e.target.value)}
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
                style={{ fontSize: 16 }}
              />
            </Grid>
          </Grid>
          <Grid sx={{ marginTop: "30px" }}>
            <AddUGProducersTrackers
              producers={ugProducersDataTrackers}
              setProducers={setUGProducersDataTrackers}
            />
          </Grid>
        </Grid>
      </>
      <>
        <Grid
          container
          sx={{
            padding: "20px",
            flexDirection: "row",
            display: "flex",
            backgroundColor: "rgba(217, 217, 217, 0.1)",
            borderRadius: 2,
            marginTop: "8px",
            marginBottom: "8px",
            rowGap: "16px ",
            width: "100%",
          }}
        >
          <Grid item xs={6} textAlign={"start"}>
            <Typography>Modules</Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{ marginTop: "-3px", marginBottom: "30px" }}
          >
            <Grid item xs={12} md={3}>
              <TextField
                label="N° de Módulos"
                value={amountModules}
                onChange={(e) => setAmountModules(e.target.value)}
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
                style={{ fontSize: 16 }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                label="Potência Instalada"
                value={powerModules}
                onChange={(e) => setPowerModules(e.target.value)}
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
                style={{ fontSize: 16 }}
              />
            </Grid>
          </Grid>
          {/* <Grid sx={{ marginTop: "30px" }}> */}
          <AddUGProducersModules
            producers={ugProducersDataModules}
            setProducers={setUGProducersDataModules}
          />
          {/* </Grid> */}
        </Grid>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <BaseButton
            title="Salvar"
            onClick={handleSave}
            // onClick={handleSubmit}
            sx={{
              backGroundColor: primary,
              borderColor: primary,
              "& .MuiTypography-root": {
                color: primary,
              },
              "&:hover": {
                borderColor: primary,
                backgroundColor: primary,
                color: primary,
                "& .MuiTypography-root": {
                  color: "#FFFFFF",
                },
              },
              marginRight: "8px",
              width: "10%",
              height: "30px",
            }}
          />
          <DangerBaseButton
            title="Cancelar"
            onClick={cancelarCadastroUG}
            sx={{
              width: "10%",
              height: "30px",
            }}
          />
        </Grid>
      </>
      {/* <ConfirmationDialog
        open={isCancelConfirmationOpen}
        title="Descartar alteração"
        message="Deseja descartar e cancelar as alterações?"
        onConfirm={handleConfirmCancel}
        onCancel={() => setCancelConfirmationOpen(false)}
        onClose={() => setCancelConfirmationOpen(false)}
      /> */}
      <ConfirmationModal
        open={isSaveConfirmationOpen}
        setOpen={() => setSaveConfirmationOpen(false)}
        title="Cadastrar UG"
        contentText="Deseja confirmar o cadastra dessa UG?"
        onConfirm={() => handleSubmit()}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />
      <ActionAlert
        message="O cadastro da UG foi realizado com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={() => setOpenSuccessModal(false)}
        onClose={() => onMount()}
      />
      <ActionAlert
        message="Ocorreu um erro ao cadastrar UG! Tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
      />

      {/* <SuccessModal
        open={openSuccessModal}
        setOpen={() => setOpenSuccessModal(false)}
        title="UG cadastrada com Sucesso!"
        contentText="O cadastro da UG foi realizado com sucesso!"
        onClose={() => onMount()}
      />
      <ErrorModal
        open={openErrorModal}
        setOpen={setOpenErrorModal}
        title="Erro ao cadastrar UG!"
        contentText="Ocorreu um erro ao cadastrar UG! Tente novamente mais tarde."
      /> */}
    </>
  );
};

export default AddUGForm;
